// 投顾相关路由
export default [
  {
    path: '/public-fund/survey',
    name: 'PublicFundSurvey',
    meta: {
      title: '公募基金适当性回访问卷'
    },
    component: () => import('../views/misc/public-fund-survey/index.vue')
  }
]
